import { state } from './state';
import { loadImageAsTexture } from './textureLoader';

// ─── Demo cover (neutral template) ─────────────────────────────────
export function loadDemoCover(): void {
  const W = state.W,
    H = state.H,
    S = state.S;
  const total = 2 * W + S;
  const w = 1300,
    h = Math.round(w * (H / total));
  const cvs = document.createElement('canvas');
  cvs.width = w;
  cvs.height = h;
  const ctx = cvs.getContext('2d')!;
  const bpx = (W / total) * w,
    spx = (S / total) * w;

  // panels
  ctx.fillStyle = '#2b2f36';
  ctx.fillRect(0, 0, w, h); // back
  ctx.fillStyle = '#23272d';
  ctx.fillRect(bpx, 0, spx, h); // spine
  const gf = ctx.createLinearGradient(bpx + spx, 0, w, h);
  gf.addColorStop(0, '#323a42');
  gf.addColorStop(1, '#262b31');
  ctx.fillStyle = gf;
  ctx.fillRect(bpx + spx, 0, w - bpx - spx, h); // front

  const accent = '#c9a96e',
    faint = 'rgba(201,169,110,0.35)',
    ink = '#e7e2d6';
  const fx = bpx + spx,
    fw = w - fx;

  // front frame
  ctx.strokeStyle = accent;
  ctx.lineWidth = 3;
  ctx.strokeRect(fx + 26, 26, fw - 52, h - 52);
  ctx.lineWidth = 1;
  ctx.strokeRect(fx + 36, 36, fw - 72, h - 72);

  // front text (generic placeholders)
  ctx.textAlign = 'center';
  ctx.fillStyle = accent;
  ctx.font = '600 ' + Math.round(h * 0.03) + 'px "Playfair Display", serif';
  ctx.fillText('AUTHOR NAME', fx + fw / 2, h * 0.14);
  ctx.fillStyle = ink;
  ctx.font = '600 ' + Math.round(h * 0.075) + 'px "Playfair Display", serif';
  ctx.fillText('YOUR TITLE', fx + fw / 2, h * 0.6);
  ctx.fillText('HERE', fx + fw / 2, h * 0.69);
  ctx.fillStyle = accent;
  ctx.font = 'italic ' + Math.round(h * 0.026) + 'px "Playfair Display", serif';
  ctx.fillText('a novel', fx + fw / 2, h * 0.77);

  // emblem
  ctx.strokeStyle = accent;
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(fx + fw / 2, h * 0.37, h * 0.075, 0, Math.PI * 2);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(fx + fw / 2, h * 0.3);
  ctx.lineTo(fx + fw / 2, h * 0.44);
  ctx.stroke();

  // spine text
  ctx.save();
  ctx.translate(bpx + spx / 2, h / 2);
  ctx.rotate(-Math.PI / 2);
  ctx.fillStyle = ink;
  ctx.textAlign = 'center';
  ctx.font = '600 ' + Math.round(spx * 0.3) + 'px "Playfair Display", serif';
  ctx.fillText('YOUR TITLE', 0, -spx * 0.05);
  ctx.fillStyle = accent;
  ctx.font = Math.round(spx * 0.19) + 'px "Playfair Display", serif';
  ctx.fillText('AUTHOR', 0, spx * 0.3);
  ctx.restore();

  // back: blurb placeholder + barcode
  ctx.fillStyle = 'rgba(231,226,214,0.55)';
  const bx = bpx * 0.16,
    bw = bpx * 0.68,
    by = h * 0.18;
  for (let i = 0; i < 7; i++) {
    const lw = i === 6 ? bw * 0.5 : bw * (0.82 + Math.random() * 0.18);
    ctx.fillRect(bx, by + i * h * 0.035, lw, h * 0.012);
  }
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(bx + bw - bpx * 0.26, h * 0.78, bpx * 0.26, h * 0.1);
  ctx.fillStyle = '#000';
  for (let i = 0; i < 18; i++) {
    if (Math.random() > 0.4)
      ctx.fillRect(bx + bw - bpx * 0.24 + i * (bpx * 0.012), h * 0.795, bpx * 0.006, h * 0.06);
  }

  // subtle section labels (instructional)
  ctx.fillStyle = faint;
  ctx.font = '600 ' + Math.round(h * 0.018) + 'px Lato, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('B A C K', bpx / 2, h * 0.95);
  ctx.fillText('F R O N T', fx + fw / 2, h * 0.93);

  loadImageAsTexture(cvs.toDataURL());
}
